@if (product$ | async; as product) {
  <section class="product-features">
    @if (product?.isAccesories && (product?.productFeature1 || product?.productFeature2 || product?.productFeature3 || product?.productFeature4)) {
      <div class="features-container">
        <h2 class="section-title">Features</h2>
        <div class="feature-grid">
          @if (product?.productFeature1) {
            <div [innerHtml]="product.productFeature1"></div>
          }
          @if (product?.productFeature2) {
            <div [innerHtml]="product.productFeature2"></div>
          }
          @if (product?.productFeature3) {
            <div [innerHtml]="product.productFeature3"></div>
          }
          @if (product?.productFeature4) {
            <div [innerHtml]="product.productFeature4"></div>
          }
        </div>
      </div>
    }
  </section>
}